<template>
  <div>
    <v-card>
      <v-card-text>
        <h1 id="fantasy-kombat">
          FantasyKombat
        </h1>
        <p>A next-generation(web3) play-to-earn fantasy sport game for combat sports.</p>
        <p>
          Become a virtual sports manager, recruit fighters, prepare training strategies and compete in both simulated
          and
          interactive gameplay tournaments.
        </p>
        <h2 id="about-the-game">
          About the game
        </h2>
        <p>
          MMA is very different from other sports and needed a unique approach. By combining the gameplay of street
          fighter,
          with pokemon style fighter attributes based on &quot;real world&quot; MMA results and fighter
          we've created an engaging game that revolves around the real world
          fight
          events.
        </p>
        <p>FantasyKombat has 3 game modes:</p>
        <ol>
          <li>Fantasy tournaments &amp; fight simulations</li>
          <li>Arcade Mode (Street fighter style &quot;Game within Game&quot;)</li>
          <li>Career Mode (Become a player or agent and work your way to the top)</li>
        </ol>
        <br>
        <p>
          Fighters real-life attributes affect in-game performance and ability, fictional fighters
          can
          also be created to compete in fictional tournaments in Simulation and Arcade Mode.
        </p>
        <p>There are 2 in-game currencies:</p>
        <p>Silver KombatCoins (free in-game use only)</p>
        <p>
          Gold KombatCoins (SPL) (play-to-earn can be purcahsed and withdrawn using $USD or "SOL") are used for premium
          features and to enter prize pools.
        </p>
        <p>
          Each fighter card is a unique NFT that can be bought/sold on the marketplace, limited edition NFTs are also in
          circulation, for special events,
        </p>
        <p>
          Fighter NFTs can have dynamic attributes linked to both fictional and non-fictional data that can appreciate
          or
          depreciate the value of the cards. (i.e fighters real-world results, in-game training to improve attributes)
        </p>
        <p>
          Just like in real life fighters stats/attributes can appreciate or depreciate the Fighter&#39;s core value
          however players can enhance attributes using fictional &quot;in-game training&quot; this results in many
          possible
          permutations of the same player depending on their &quot;team strategy&quot;, &quot;training&quot; and advisor
          &quot;power-ups&quot;.
        </p>
        <h2 id="getting-started">
          Getting Started
        </h2>
        <ul>
          <li>
            You&#39;ll receive 2 million Silver KombatCoins (in-game only currency, Only Gold KombatCoins can be
            withdrawn as "SOL")
          </li>
          <li>
            Create a team and select your &quot;advisor&quot; advisor cards to activate power-ups for certain
            attributes,
            so should be chosen/changed to align with the power-ups of your players to enhance their attributes.
          </li>
          <li>
            &quot;Recruit&quot; fighters from the marketplace. The value of &quot;Base&quot; cards is based on their
            rank,
            win/loss ratio and "xfactor". The "xfactor" is our own algorithm that provides a multiplier based on
            sponsorship
            deals, social media footprint and fight frequency.
            <br>
            For each fight event you pick which fighter will win and
            how
            (Decision / Knockout or Submission).
          </li>
          <li>
            Select a team &quot;training strategy&quot; these provide attribute powers ups that increase incrementally
            the
            longer you own a player, this incentives you keep plays to increase their value which can later be sold for
            profit.
          </li>
          <li>
            Players can link their Solana wallets (Support for Phantom, Solflare and Solong) to purchase Gold Kombat
            Coins
            to purchase more players and enter play-to-earn events that offer prizes in the form of either Silver/Gold
            Kombat
            Coins or fighter/advisor NFT unlike base fighter NFTs prizes are often &quot;limited edition&quot; NFTs
            which
            are immune against fighter core value depreciation as a result of real-world events.
          </li>
          <li>Players can be sold in the marketplace for Gold KombatCoins and any profits can be withdrawn as SOL.</li>
        </ul>
        <br>
        <h2 id="fight-events-">
          Fight Events:
        </h2>
        <p>Fight events are linked to real-world fight tournaments.</p>
        <ul>
          <li>For each event choose who will win and how (Decision/KnockOut/Submission)</li>
          <li>Silver KombatCoins are awarded for choosing the correct results</li>
          <li>If you own players in the fight you get a 2x multiplier on their fantasy fight points</li>
          <li>Team Captains (1 fighter per event) get 3x their KombatCoin pool winnings</li>
          <li>
            In UFC events Fighters can earn &quot;Fight of the night&quot; and &quot;Performance of the night bonuses&quot;
            these are publicly announced as cash prizes (i.e $50K USD) if you own fighters in these events you get the
            same
            numerical value (50K) in Silver KombatCoins
          </li>
          <li>
            If a fighter misses weight in real-world they lose a portion of their winnings, same is true for
            FantasyKombat fighters the portions lost is proportional. (publicly available data)
          </li>
          <li>
            After each event your total wings will be distributed into your wallet, leaderboards will show per event
            leaders, accumulated leaders for all events and league leaders
          </li>
          <li>
            Players can create private leagues and invite friends or join public leagues to compete with strangers or
            friends in a much more competitive way, auto-generated leagues will place new fighters in cohorts to help
            align
            with time/experience in the game.
          </li>
        </ul>
        <br>
        <h2 id="arcade-events">
          Arcade Events
        </h2>
        <p>Within the game there is an Arcade game machine with a 2 player game largely inspired by streetfighter.</p>
        <ul>
          <li>Players can play the arcade for free 3 times per week</li>
          <li>Player can pay silver or gold coins to play more</li>
          <li>Fighters in the game are currently based on the next UFC main event.</li>
          <li>
            There are periodic knockout competitions for arcade mode with prizes for Winners,\
            finalists and quarter-finalists (prizes vary and are published with the event details)
          </li>
          <li>In Practise mode you can only choose fighters from the next UFC main event</li>
          <li>For arcade events\tournaments you can only choose fighters you own (coming soon)</li>
          <li>Attributes like power, speed, recovery and health vary based your players &quot;power ups&quot;</li>
        </ul>
        <br>
        <h2 id="career-events-coming-soon-">
          Career Mode (coming soon)
        </h2>
        <p> Choose to be a Fighter or Agent.</p>
        <h4 id="fighters-">
          Fighters:
        </h4>
        <ul>
          <li>Choose the martial arts and time dedicated to each (time is finite)</li>
          <li>Choose gyms, training partners and coaches</li>
          <li>Obtain sponsors to increase earning</li>
          <li>
            Once you develop your player to &quot;base&quot; level you can add the fictional fighter to the game and can
            be used just like non-fictional fighters (Real-world fight events are simulated and outcomes determined by
            our
            algorithm)
          </li>
          <li>
            Earning opportunities through fidget events are periodically offered and increase over time based on
            experience, time &quot;trained&quot; and arcade/simulated event outcomes
            - Goal is to join a Pro Circuit and get ranked, the fight for the belt!
          </li>
        </ul>
        <br>
        <h4 id="agents">
          Agents:
        </h4>
        <ul>
          <li>
            Scout up and coming players in the real world, if these players get recruited earn contract commissions
          </li>
          <li>
            Periodic gold coin options will become available to accelerate your career progress
          </li>
          <li>
            Organise upcoming fight events (simulated) and earn commission on won fights.
          </li>
          <li>
            Help your players get ranked, or become world champs.
          </li>
          <li>Goal accumulate as much virtual currency as possible</li>
        </ul>
        <br>
        <h2 id="next-on-the-roadmap-">
          Next on the roadmap:
        </h2>
        <ul>
          <li>Leaderboards</li>
          <li>Improved career mode</li>
          <li>Create your own fictional fighters for in-game (Arcade and simulated events)</li>
          <li>More fighter styles and sprites for arcade game</li>
          <li>Syndicates and private prize pools (p2p amongst "friends")</li>
          <li>League prize pools</li>
        </ul>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {mdiAlert} from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiAlert,
      },
    }
  },
}
</script>

<style lang="scss">
</style>
